// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-style[data-v-cd5faa4a]{height:.3rem!important;width:1.2rem}[data-v-cd5faa4a] .form-row-inner-container{grid-template-columns:3rem 6.5rem!important}", ""]);
// Exports
module.exports = exports;
